import { render, staticRenderFns } from "./BaseBackdrop.vue?vue&type=template&id=6d3c6157"
import script from "./BaseBackdrop.vue?vue&type=script&lang=js"
export * from "./BaseBackdrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports